<template>
  <div id="content-container">
    <div class="panel">
      <div class="filter">
        <el-form
          label-position="right"
          class="search-form"
          label-width="70px"
          inline
          @submit.native.prevent
        >
          <el-form-item label="关键字" prop="name">
            <el-input
              size="small"
              v-model="filter.query"
              autocomplete="off"
              placeholder="输入姓名或手机号进行搜索"
              @keyup.enter.native="query()"
            ></el-input>
          </el-form-item>
          <el-form-item label="角色" prop="name">
            <el-select
              style="width: 100%"
              v-model="filter.role_name"
              size="small"
              placeholder="请选择角色"
            >
              <el-option
                v-for="item in allRoles"
                :key="item.id"
                :label="item.name"
                :value="item.name"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="基地">
            <BaseSelect v-model="filter.base_id" :clearable="true"></BaseSelect>
          </el-form-item>
        </el-form>
        <div style="margin-left: 70px">
          <el-button type="primary" size="small" @click="query()"
            >筛选</el-button
          >
          <el-button size="small" @click="reset()">重置</el-button>
        </div>
      </div>
    </div>
    <div class="panel mt-20">
      <el-button
        type="primary"
        size="small"
        icon="el-icon-plus"
        @click="handleNew"
        v-permission="Auth.userNew"
        >新增人员</el-button
      >
      <el-table :data="staffs" size="small" class="mt-10">
        <el-table-column prop="name" label="姓名"> </el-table-column>
        <el-table-column prop="phone_number" label="手机号"></el-table-column>
        <el-table-column prop="base.name" label="基地"></el-table-column>
        <el-table-column label="角色" align="left">
          <template slot-scope="scope">{{
            showRoles(scope.row.auth_roles)
          }}</template>
        </el-table-column>
        <el-table-column label="状态" align="center">
          <template slot-scope="scope">
            <span
              :class="scope.row.status == 1 ? 'text-success' : 'text-danger'"
            >
              {{ scope.row.status == 1 ? '已启用' : '已禁用' }}
            </span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="操作">
          <template slot-scope="scope">
            <el-popconfirm
              v-permission="Auth.userStatus"
              :title="`确认${scope.row.status == 1 ? '禁用' : '启用'}吗？`"
              @confirm="handleSwitchStatus(scope.$index, scope.row.id)"
            >
              <el-button slot="reference" type="text" size="small">{{
                scope.row.status == 1 ? '禁用' : '启用'
              }}</el-button>
            </el-popconfirm>
            <el-popconfirm
              v-permission="Auth.resetUserPassword"
              :title="`确认重置密码为：88888888 吗？`"
              @confirm="handleResetPassword(scope.row.id)"
            >
              <el-button slot="reference" type="text" class="ml-10" size="small"
                >重置密码</el-button
              >
            </el-popconfirm>
            <el-button
              type="text"
              size="small"
              class="ml-10"
              @click="handleEdit(scope.$index, scope.row)"
              v-permission="Auth.userEdit"
              >编辑</el-button
            >
            <!-- <el-button
              type="text"
              size="small"
              @click="handleShowAuth(scope.row)"
              >权限</el-button
            > -->
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        class="mt-20"
        :page-size="filter.size"
        :current-page.sync="filter.page"
        layout="total, prev, pager, next"
        :total="total"
      ></el-pagination>

      <Former
        :model="model"
        :show.sync="dialogVisible"
        @created="createdCallback"
        @updated="updatedCallback"
      ></Former>

      <UserAuth :userId="userId" :show.sync="userAuthVisible"></UserAuth>
    </div>
  </div>
</template>

<script>
import {
  userList,
  switchUserStatus,
  roleList,
  resetUserPassword,
} from '@/service/getData'
import Former from './former'
import UserAuth from './user_auth'
import BaseSelect from '../../components/select/base_select.vue'

export default {
  components: {
    Former,
    UserAuth,
    BaseSelect,
  },
  watch: {
    'filter.page': function () {
      this.getUsers()
    },
  },
  data() {
    return {
      model: {},
      filter: {
        page: 1,
        size: 10,
        query: '',
        role_name: '',
        base_id: 0,
      },
      allRoles: [],
      total: 0,
      editIndex: 0,
      staffs: [],
      dialogVisible: false,
      rules: {
        name: [
          { required: true, message: '请填写姓名', trigger: 'blur' },
          {
            min: 2,
            max: 15,
            message: '长度在 2 到 15 个字符',
            trigger: 'blur',
          },
        ],
      },
      userId: 0,
      userAuthVisible: false,
    }
  },
  created() {
    this.getUsers()
    this.getRoles()
  },
  methods: {
    query() {
      this.filter.page = 1
      this.getUsers()
    },
    async getUsers() {
      let data = {
        size: this.filter.size,
        page: this.filter.page - 1,
        query: this.filter.query,
        role_name: this.filter.role_name,
        base_id: this.filter.base_id,
      }
      let res = await userList(data)
      if (res.code == 0) {
        this.staffs = res.data.list
        this.total = res.data.count
      }
    },
    showRoles(roles) {
      if (!roles) return ''
      let names = roles.map((item) => {
        return item.name
      })
      return names.join(' / ')
    },
    createdCallback(data) {
      this.staffs.unshift(data)
    },
    updatedCallback(data) {
      this.$set(this.staffs, this.editIndex, data)
    },
    handleNew() {
      this.model = {
        name: '',
        phone_number: '',
        base_id: 1,
        roles: [],
      }
      this.dialogVisible = true
    },
    handleEdit(index, item) {
      let roles = item.auth_roles
        ? item.auth_roles.map((item) => {
            return item.id
          })
        : []
      this.dialogVisible = true
      this.$nextTick(() => {
        this.model = {
          id: item.id,
          name: item.name,
          phone_number: item.phone_number,
          roles: roles,
          base_id: item.base_id,
        }
        this.editIndex = index
      })
    },
    async handleSwitchStatus(index, id) {
      let res = await switchUserStatus(id)
      if (res.code == 0) {
        this.staffs[index].status = res.data.status
        this.$message({
          message: `操作成功`,
          type: 'success',
          center: true,
        })
      }
    },
    async handleResetPassword(id) {
      let res = await resetUserPassword(id)
      if (res.code == 0) {
        this.$message({
          message: `密码重置成功！`,
          type: 'success',
          center: true,
        })
      }
    },
    async getRoles() {
      let res = await roleList()
      if (res.code == 0) {
        this.allRoles = res.data.list.filter((item) => item.status == 1)
      }
    },
    reset() {
      this.filter.page = 1
      this.filter.role_name = ''
      this.filter.query = ''
      this.filter.base_id = 0
      this.getUsers()
    },
    handleShowAuth(item) {
      this.userId = item.id
      this.userAuthVisible = true
    },
  },
}
</script>